<template>
  <div>
    <div>
      <div class="top">
        <el-input
            v-model="search.cpmc"
            placeholder="产品名称"
            style="width: 155px; margin:0 10px 20px 0"
            size="small"
            clearable
            @clear="clear('cpmc')"
        />

        <select-from-dictionary
          :code="'guaranty'"
          :placeholder="'担保方式'"
          :default-val="search.dbfsc"
          :cus-style="'width: 155px; margin:0 10px 20px 0'"
          size="small"
          @change="changeGuaranty"
        />
        <el-button
          icon="el-icon-search"
          size="small"
          @click="queryData()"
          >查询</el-button>

          <el-button
          type="success"
          icon="el-icon-plus"
          size="small"
          @click="handleAdd()"
          >发布金融产品</el-button>

      </div>

      <el-table
        ref="multipleTable"
        :data="tableData"
        :highlight-current-row="true"
        stripe
        row-key="id"
        style="width: 100%; height: 100%;padding-top: 20px;border-radius:16px;"
      >
        <el-table-column type="index" label="序号" width="55" />
        <el-table-column prop="cpmc" width="150" label="产品名称" />
        <el-table-column prop="dkedxx" label="贷款额度">
        <template slot-scope="scope">
            <span>{{ scope.row.dkedxx +' ~ '+ scope.row.dkedsx + '万元'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dkqxxx" label="贷款期限">
          <template slot-scope="scope">
            <span>{{ scope.row.dkqxxx +' ~ '+ scope.row.dkqxsx + '月'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="zdnhlv" label="年利率范围"  width="110" >
          <template slot-scope="scope">
            <span>{{ scope.row.zdnhlv+'%' +' ~ '+ scope.row.zgnhlv + '%'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dbfsm" label="担保方式" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.dbfsm || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dklxm" label="信贷类型"  />
        <el-table-column prop="khjl" label="客户经理"  width="80" />
        <el-table-column prop="lxrdh" label="联系电话" width="125" />
        <el-table-column prop="publishTime" label="发布时间" width="160">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.publishTime || scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="cpms" width="160" label="产品描述">
          <template slot-scope="scope">
            <el-popover placement="top-start" width="260" trigger="hover">
              <div class="table-popover custom-scrollbar" v-html="scope.row.cpms"></div>
              <div slot="reference" class="table-text">{{ scope.row.cpms }}</div>
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column  label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, sizes,prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page.sync="page.current"
          :page-size.sync="page.size"
          :total="page.total"
          @current-change="queryData"
          @size-change="handleQuery"
        />
      </div>
    </div>
     <!-- 新增修改 -->
     <edit-dialog
      v-if="editDialogData.visible"
      :viewData="editDialogData.viewData"
      :show-dialog="editDialogData.visible"
      :dialog-title="editDialogData.title"
      @closeDialog="closeEditDialog"
    />

  </div>
</template>

<script>
import {getProductPage , deleteProduct} from "@/views/financInstitutionPC/viewApi";
import { downloadFile } from "@/utils/index";
import editDialog from "./editDialog";

export default {
  components: {
    editDialog
  },
  data() {
    return {
      search:{
        cpmc:'',
        dbfsc:''
      },
      options:[],
      loading: false,
      page: {
        size: 10,
        total: 0,
        current: 1
      },
      tableData:[],
      editDialogData: {
        visible: false,
        id: null,
        title: "新增",
      },
    }
  },
  mounted() {
    this.queryData();
  },
  methods: {

    handleQuery () {
      this.page.current = 1
      this.queryData()
    },
    queryData(){
      let param ={
        cpmc: this.search.cpmc,
        dbfsc: this.search.dbfsc,
        ...this.page,
      }
      getProductPage(param).then(res => {
        if (res.code == 1000) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      })
    },

    changeGuaranty(data){
      this.search.dbfsc = data.code;
      this.search.dbfsm = data.dictionaryKey;
      queryData()
    },

    // 新增
    handleAdd() {
      this.editDialogData.title = "新增金融产品";
      this.editDialogData.visible = true;
    },
    handleEdit(row) {
      this.editDialogData.title = "修改金融产品";
      this.editDialogData.viewData = {...row};
      this.editDialogData.visible = true;
    },
    handleDelete(row) {
      this.$confirm(`确认删除吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((_) => {
        deleteProduct({id:row.id}).then((res) => {
          this.$baseMessage("删除成功。", "success");
          this.queryData();
        });
      });
    },

    changeItem( data ){
      this.search.cpmc = data.cpmc;
    },

    clear(key){
      key&&(this.search[key] = '')
      this.queryData();
    },

    // 关闭新增修改弹窗
    closeEditDialog(needRefresh) {
      this.editDialogData.viewData = null;
      this.editDialogData.visible = false;
      if (needRefresh) {
        this.queryData();
      }
    },

    reseData(){
      this.search={
        cpmc:'',
        dbfsc:''
      };
    },

    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },

  }
};
</script>
